module.exports = __webpack_public_path__ + "img/300x210.c9a7e052.jpg";